import { gql } from '@apollo/client';

export const SMOKING_STATUS_QUERY = gql`
  query fetchSmokingStatus(
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchSmokingStatus(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      smokingStatusList
      count
    }
  }
`;
